import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROOT_PATH } from '../../router/constants';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';

export function useAutoNavigateToTheEditUnitPage() {
    const unitAssignment = useUnitAssignment();
    const navigate = useNavigate();

    useEffect(
        function autoNavigateToTheEditUnitPage() {
            if (!unitAssignment?.unitId && ['', '#/', '#'].includes(window?.location?.hash)) {
                navigate(ROOT_PATH);
            }
        },
        [navigate, unitAssignment?.unitId]
    );
}
